import { FaultRow } from 'components/tables/data/fault/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the fault id.
 */
export default function FaultIdColumn({ data: { faultId } }: { data: FaultRow }) {
  return <P3Regular color="gray.8">{faultId}</P3Regular>;
}
